module.exports = __webpack_public_path__ + "img/banner06.c08c36b6.jpg";